import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateAndTimeShow',
})
@Injectable({
  providedIn: 'root',
})
export class DateAndTimeShowPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC', // ⬅️ Ensures it formats in UTC
    });
  }
}
